<template>
<div>
  <form>
    <div class="columns">
      <div class="column">
        <text-input
          :error="$root.errorBag.name"
          :value="environment.name"
          @input="updateName"
          required>
          Name
        </text-input>
      </div>
      <div class="column">
        <text-input 
          classes="has-addons"
          :value="environment.public_url"
          :error="$root.errorBag.public_url"
          @input="updatePublicUrl"
          hint="Changing this value will trigger a TLS scan">
          <template #left>
            <button class="is-static button">https://</button>
          </template>
          Domain
        </text-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button :working="working" @submit="store" left-icon="save">Save</submit-button>
      </div>
    </div>
  </form>  
</div>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { clientConfig } from '@/modals'

export default {

  data: () => ({
    working: false
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'New Environment')
  },

  created() {
    this.clearEnvironment()
  },

  methods: {
    ...mapMutations('environment', [
      'updateName',
      'clearEnvironment',
      'updatePublicUrl'
    ]),
    store() {
      this.working = true
      this.$store.dispatch('environment/store', { appId: this.app.id, ...this.environment }).then(async environment => {
        this.working = false
        await clientConfig(environment)
        this.$router.push({
          name: 'app-environments',
          params: {
            app: this.app.id
          }
        })
      }).catch(error => {
        console.log(error)
        this.working = false
        this.$toast.error('Whoops please try again')
      })
    }
  },

  computed: {
    ...mapGetters('environment', [
      'environment'
    ]),
    ...mapGetters('app', [
      'app'
    ])
  }
}
</script>